<template>
    <footer class="main-footer">
        <div class="container">
            <div class="main-footer__wrap">
                <div class="main-footer__wrap__intro">
                    <router-link to="/" class="main-footer__wrap__intro__link">
                        <img
                            class="main-footer__wrap__intro__link__logo"
                            src="/images/falagrett-logo-white.svg"
                            alt="falagrett"
                        />
                    </router-link>

                    <p class="main-footer__wrap__intro__txt">
                        Vi ser till att din kompetens alltid förvaltas och kommer till nytta.
                    </p>
                    <p class="main-footer__wrap__intro__txt">
                        Vårt mission är att hjälpa företag och människor att nyttja hela sitt kompetenskapital
                    </p>
                    <p class="main-footer__wrap__intro__txt">100% digitalt såklart</p>
                </div>

                <div class="main-footer__wrap__menu">
                    <template v-if="currentDepartment && (isCertifier || isEmployAdmin)">
                        <template v-if="currentDepartment?.type === DepartmentType.Educate">
                            <ul class="main-footer__wrap__menu__list">
                                <li class="main-footer__wrap__menu__list__item">
                                    <router-link
                                        :to="{ name: 'certificate' }"
                                        class="main-footer__wrap__menu__list__item__link"
                                        title="Se Certifikat"
                                    >
                                        Utfärdade certifikat
                                    </router-link>
                                </li>
                                <li class="main-footer__wrap__menu__list__item">
                                    <router-link
                                        :to="{ name: 'create-certificate' }"
                                        class="main-footer__wrap__menu__list__item__link"
                                        title="Skapa Certifikat"
                                    >
                                        Skapa certifikat
                                    </router-link>
                                </li>
                            </ul>
                        </template>

                        <template v-if="currentDepartment?.type === DepartmentType.Employ">
                            <ul class="main-footer__wrap__menu__list">
                                <li class="main-footer__wrap__menu__list__item">
                                    <router-link
                                        :to="{ name: 'employ-dashboard' }"
                                        class="main-footer__wrap__menu__list__item__link"
                                        title="Editera företags- och certifikatuppgifter"
                                    >
                                        Översikt
                                    </router-link>
                                </li>
                                <li class="main-footer__wrap__menu__list__item">
                                    <router-link
                                        :to="{ name: 'employ-certificate' }"
                                        class="main-footer__wrap__menu__list__item__link"
                                        title="Se Certifikat"
                                    >
                                        Alla certifikat
                                    </router-link>
                                </li>
                                <li class="main-footer__wrap__menu__list__item">
                                    <router-link
                                        :to="{ name: 'employ-create-certificate' }"
                                        class="main-footer__wrap__menu__list__item__link"
                                        title="Utfärda Certifikat"
                                    >
                                        Utfärda certifikat
                                    </router-link>
                                </li>
                            </ul>
                        </template>

                        <ul class="main-footer__wrap__menu__list">
                            <template v-if="currentDepartment?.type === DepartmentType.Educate">
                                <li class="main-footer__wrap__menu__list__item">
                                    <router-link
                                        :to="{ name: 'payment' }"
                                        class="main-footer__wrap__menu__list__item__link"
                                        title="Abonnemang och betalning "
                                    >
                                        Abonnemang och betalning
                                    </router-link>
                                </li>
                                <li class="main-footer__wrap__menu__list__item">
                                    <router-link
                                        :to="{ name: 'settings' }"
                                        class="main-footer__wrap__menu__list__item__link"
                                        title="Editera företags- och certifikatuppgifter"
                                    >
                                        Företags- och certifikatuppgifter
                                    </router-link>
                                </li>
                                <li class="main-footer__wrap__menu__list__item">
                                    <router-link
                                        :to="{ name: 'users' }"
                                        class="main-footer__wrap__menu__list__item__link"
                                        title="Editera användare"
                                    >
                                        Användare
                                    </router-link>
                                </li>
                                <li class="main-footer__wrap__menu__list__item">
                                    <router-link
                                        :to="{ name: 'competencies' }"
                                        class="main-footer__wrap__menu__list__item__link"
                                        title="Editera kompetenser"
                                    >
                                        Kompetenser
                                    </router-link>
                                </li>
                            </template>

                            <template v-if="currentDepartment?.type === DepartmentType.Employ">
                                <li v-if="userPermissions?.payments?.read" class="main-footer__wrap__menu__list__item">
                                    <router-link
                                        :to="{ name: 'payment' }"
                                        class="main-footer__wrap__menu__list__item__link"
                                        title="Abonnemang och betalning "
                                    >
                                        Abonnemang och betalning
                                    </router-link>
                                </li>
                                <li v-if="userPermissions?.settings?.read" class="main-footer__wrap__menu__list__item">
                                    <router-link
                                        :to="{ name: 'employ-settings' }"
                                        class="main-footer__wrap__menu__list__item__link"
                                        title="Editera företags- och certifikatuppgifter"
                                    >
                                        Företags- och certifikatuppgifter
                                    </router-link>
                                </li>

                                <li class="main-footer__wrap__menu__list__item">
                                    <router-link
                                        :to="{ name: 'employ-employees' }"
                                        class="main-footer__wrap__menu__list__item__link"
                                        title="Se och hantera dina medarbetare"
                                    >
                                        Medarbetare
                                    </router-link>
                                </li>
                                <li class="main-footer__wrap__menu__list__item">
                                    <router-link
                                        :to="{ name: 'employ-competences' }"
                                        class="main-footer__wrap__menu__list__item__link"
                                        title="Se och hantera dina medarbetare"
                                    >
                                        Roller och kompetenser
                                    </router-link>
                                </li>
                            </template>

                            <li class="main-footer__wrap__menu__list__item">
                                <router-link
                                    :to="{ name: 'account' }"
                                    class="main-footer__wrap__menu__list__item__link"
                                >
                                    Mitt konto
                                </router-link>
                            </li>
                        </ul>
                    </template>

                    <ul class="main-footer__wrap__menu__list">
                        <li class="main-footer__wrap__menu__list__item">
                            <a
                                class="main-footer__wrap__menu__list__item__link"
                                :href="ABOUT_CERVD_URL"
                                target="_blank"
                            >
                                Om Falagrett
                            </a>
                        </li>
                        <li class="main-footer__wrap__menu__list__item">
                            <a class="main-footer__wrap__menu__list__item__link" :href="CONTACT_URL" target="_blank">
                                Kontakt
                            </a>
                        </li>
                        <li class="main-footer__wrap__menu__list__item">
                            <a
                                class="main-footer__wrap__menu__list__item__link"
                                :href="PRIVACY_POLICY_URL"
                                target="_blank"
                            >
                                Integritetspolicy
                            </a>
                        </li>
                        <li class="main-footer__wrap__menu__list__item">
                            <a
                                class="main-footer__wrap__menu__list__item__link"
                                :href="TERMS_OF_USE_URL"
                                target="_blank"
                            >
                                Användarvillkor
                            </a>
                        </li>
                    </ul>
                </div>
            </div>

            <div class="main-footer__copyright">
                <p class="main-footer__copyright__txt">
                    Falagrett AB, Kyrkgatan 76 831 34 Östersund, Sverige. All rights reserved.<br />
                    Copyright &copy; {{ new Date().getFullYear() }} Falagrett AB.
                </p>
            </div>
        </div>
    </footer>
</template>

<script>
    import { computed } from 'vue';
    import { useStore } from 'vuex';
    import { DepartmentType } from '@enums/DepartmentType';
    import usePermissions from '@composables/usePermissions';

    export default {
        setup() {
            const store = useStore();
            const userPermissions = usePermissions();

            const ABOUT_CERVD_URL = process.env.MIX_ABOUT_CERVD_URL || '#';
            const CONTACT_URL = process.env.MIX_CONTACT_URL || '#';
            const PRIVACY_POLICY_URL = process.env.MIX_PRIVACY_POLICY_URL || '#';
            const TERMS_OF_USE_URL = process.env.MIX_TERMS_OF_USE_URL || '#';

            const currentDepartment = computed(() => store.getters['Departments/GET_CURRENT_DEPARTMENT']);

            const isEmployAdmin = computed(() => store.getters['UserStore/CAN_USER']('employ.*'));
            const isCertifier = computed(() => store.getters['UserStore/CAN_USER']('certificate.*'));

            return {
                ABOUT_CERVD_URL,
                CONTACT_URL,
                PRIVACY_POLICY_URL,
                TERMS_OF_USE_URL,
                currentDepartment,
                isEmployAdmin,
                isCertifier,
                DepartmentType,
                userPermissions,
            };
        },
    };
</script>
